import { render, staticRenderFns } from "./trabajadorLista.vue?vue&type=template&id=c5faaed6&"
import script from "./trabajadorLista.vue?vue&type=script&lang=js&"
export * from "./trabajadorLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports